module.exports = __webpack_public_path__ + "static/media/sith.91019916.svg";